import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, IconButton, Typography, Box, Stack, Switch, Paper
} from '@mui/material';

function ReceiptDialogEditPrivacy({ isOpen, onClose, receipt, onSave }) {
    // We use is_private. If true, only the owner sees it.
    const [isPrivate, setIsPrivate] = useState(false);

    useEffect(() => {
        if (isOpen && receipt) {
            setIsPrivate(receipt.private || false);
        }
    }, [isOpen, receipt]);

    const handleSave = () => {
        onSave(receipt.id, { private: isPrivate });
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            PaperProps={{
                sx: { borderRadius: '25px', padding: '8px', minWidth: 400 }
            }}
        >
            {/* Professional Header */}
            <DialogTitle sx={{
                p: 3,
                textAlign: 'center',
                background: 'linear-gradient(135deg, #151269 0%, #352fcc 100%)',
                color: 'white',
                borderRadius: '20px 20px 8px 8px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '1px' }}>
                    PRIVACY SETTINGS
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8, textTransform: 'uppercase' }}>
                    Control who can view this receipt
                </Typography>
            </DialogTitle>

            <IconButton onClick={onClose} sx={{ position: 'absolute', right: 16, top: 16, color: 'white' }}>
                <i className="icon-cross" style={{ fontSize: '18px' }} />
            </IconButton>

            <DialogContent sx={{ mt: 3 }}>
                <Paper
                    elevation={0}
                    sx={{
                        p: 3,
                        borderRadius: '20px',
                        bgcolor: isPrivate ? 'rgba(156, 39, 176, 0.04)' : 'rgba(76, 175, 80, 0.04)',
                        border: '1px solid',
                        borderColor: isPrivate ? '#9c27b0' : '#4caf50',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Box>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <i
                                    className={isPrivate ? "icon-lock" : "icon-unlocked"}
                                    style={{
                                        fontSize: '20px',
                                        color: isPrivate ? '#9c27b0' : '#4caf50'
                                    }}
                                />
                                <Typography variant="h6" sx={{ fontWeight: 700, color: '#151269' }}>
                                    {isPrivate ? "Private" : "Public"}
                                </Typography>
                            </Stack>
                            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                {isPrivate
                                    ? "Only you can see this receipt. It will be hidden from other event collaborators."
                                    : "Everyone invited to this event can view and download this receipt."}
                            </Typography>
                        </Box>

                        <Switch
                            checked={isPrivate}
                            onChange={(e) => setIsPrivate(e.target.checked)}
                            color="secondary"
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#9c27b0' },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#9c27b0' },
                            }}
                        />
                    </Stack>
                </Paper>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
                <Button onClick={onClose} sx={{ color: '#6c757d', fontWeight: 600 }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    sx={{
                        borderRadius: '12px',
                        px: 4,
                        bgcolor: '#151269',
                        '&:hover': { bgcolor: '#352fcc' }
                    }}
                >
                    Apply Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ReceiptDialogEditPrivacy;